import { AddonParams, BaseAddon } from "../base/BaseAddon";
import { StepChangeEvent, StepState, StepType } from "../../types/types";
import toastService from "../../../../../core/toaster/ToasterService";
import { TOASTER_TOAST_TIME } from "../../../../../core/toaster/Toaster_model";
import { SelectHeaderStep } from "../../components/SelectHeaderStep/SelectHeaderStep";
import { NoDataFound } from "../../components/NotFound/NoDataFound";

interface SelectHeaderAddonParams<T extends string = string> extends AddonParams<T> {
  selectHeaderStepHook?: (headerValues: any[], data: any) => Promise<any>;
}

export class SelectHeaderStepAddon<T extends string = string> extends BaseAddon<T> {
  selectHeaderStepHook?: (headerValues: any[], data: any) => Promise<any>;
  protected onBack: () => void;

  constructor(onNext: (event: StepChangeEvent) => void, onBack: () => void, params: SelectHeaderAddonParams<T>) {
    super("SelectHeaderStepAddon", [StepType.selectHeader], onNext, params);
    this.selectHeaderStepHook = params.selectHeaderStepHook;
    this.onBack = onBack;
  }

  protected getJSXElement(step: StepType, state: StepState): React.ReactElement {
    if (!state.data) {
      return <NoDataFound onBack={this.onBack}></NoDataFound>;
    }

    return (
      <SelectHeaderStep
        data={state.data}
        onContinue={async (headerIndex: number) => {
          await this.handleHeaderSelection(state.data, headerIndex);
        }}
        onBack={this.onBack}
      />
    );
  }
  private async handleHeaderSelection(data: string[][], headerIndex: number): Promise<void> {
    try {
      const headerValues = data[headerIndex];
      const dataValues = data.slice(0, headerIndex).concat(data.slice(headerIndex + 1));

      if (this.selectHeaderStepHook) {
        const result = await this.selectHeaderStepHook(headerValues, dataValues);

        this.onNext({
          type: StepType.matchColumns,
          data: result.data || dataValues,
          headerValues: result.headerValues || headerValues
        });
      } else {
        this.onNext({
          type: StepType.matchColumns,
          data: dataValues,
          headerValues: headerValues
        });
      }
    } catch (e) {
      console.error("Error in header selection:", e);
      toastService
        .showErrorToast(TOASTER_TOAST_TIME.NORMAL, "right")
        .setContent(<span>{e?.message || "An error occurred processing the headers"}</span>);
    }
  }
}
